@if (msalAuthEnabled && entraAuthService.isLoading()) {
  <app-loading-login />
} @else {
  <router-outlet />
}
